<template>
  <div class="select-row" v-if="data">
    <div class="label">{{ label }}</div>
    <div class="row__content">
      <span
        v-for="(item, index) in data"
        class="select-btn"
        :key="index"
        @click="handleClick({ type: type, data: item }, $event)"
      >
        <template>{{ item.name }}</template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['type', 'data', 'label'],
  data() {
    return {}
  },
  methods: {
    handleClick(data, event) {
      this.$emit('input', data, event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.select-row {
  min-height: 12px;
  line-height: 12px;
  // padding: 8px 0;
  position: relative;
  font-size: 12px;
  // margin-bottom: 6px;
  .label {
    float: left;
    color: #999999;
    font-weight: normal;
    text-align: left;
    // margin-right: 8px;
    min-width: 48px;
  }
  .bold {
    color: #666666;
    font-weight: bold;
  }
  .row__content {
    display: inline-block;
    position: relative;
    max-width: 1074px;
    vertical-align: top;
  }
}
@include b(select-btn) {
  padding: 0 6px;
  margin: 0 6px;
  line-height: 12px;
  display: inline-block;
  color: #333333;
  cursor: pointer;
  position: relative;
  margin-bottom: 20px;
  &:hover {
    color: #f13232;
  }
  @include m(active) {
    border-radius: 2px;
    color: #ffffff;
    background: #f13232;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05);
    &:hover {
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/SelectRow.vue